// The raw document, behind a toggle.
//
// Was an accordion like every other card, which put "the entire user document as
// JSON" at the same weight as Identity. It is a debugging escape hatch — permission
// gated, opened rarely, and long — so it reads as one collapsed row until asked for.
import { useState } from 'react';
import { Box } from '../../ui/core';
import { scrollY } from '../../ui/styles';
import { InfoIcon } from '../../ui/icons';
import { SectionCard } from '../../pages/DriverProfile/components';
import { Row, RowAction, TrailingMeta } from '../../pages/UserProfile/parts';

export default ({ title, jsonObject }) => {
  const [open, setOpen] = useState(false);

  return (
    <SectionCard
      title={title}
      icon={<InfoIcon sx={{ fontSize: 17, color: 'text.secondary', flexShrink: 0 }} />}
      meta={
        <TrailingMeta>
          <RowAction onClick={() => setOpen((v) => !v)}>{open ? 'Hide' : 'Show'}</RowAction>
        </TrailingMeta>
      }
    >
      {open ? (
        <Box sx={{ px: 1.75, py: 1.5, maxHeight: 420, ...scrollY }}>
          <Box component="pre" sx={{ m: 0, fontSize: '11.5px', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {JSON.stringify(jsonObject, null, 2)}
          </Box>
        </Box>
      ) : (
        <Row first label="Hidden" meta="The whole user document, exactly as the API returned it." />
      )}
    </SectionCard>
  );
};
